// libraries
import "script-loader!jquery";

// slurped js
import "script-loader!../../../../mu-plugins/gravityforms/js/jquery.json.js";
import "script-loader!../../../../mu-plugins/gravityforms/js/gravityforms.js";
import "script-loader!../../../../mu-plugins/gravityforms/js/jquery.maskedinput.min.js";
import "script-loader!../../../../mu-plugins/gravityforms/js/placeholders.jquery.min.js";
import "script-loader!../../../../mu-plugins/gravityforms/js/conditional_logic.min.js";
import "script-loader!../../../../plugins/gravityformsutmtracking/js/jquery-utmz";
import "script-loader!../../../oncarrot/includes/js/forms.js";
import "script-loader!../../bower_components/lity/dist/lity";
import "script-loader!../../bower_components/slick-carousel/slick/slick";
import "script-loader!../../bower_components/fluidvids/dist/fluidvids";
import "script-loader!../../bower_components/pickadate/lib/picker";
import "script-loader!../../bower_components/pickadate/lib/picker.date";
import "script-loader!../../bower_components/pickadate/lib/picker.time";
import "script-loader!../../bower_components/svg4everybody/dist/svg4everybody";

// Excluded: alert, button, carousel, popover, scrollspy, tooltip
import "script-loader!../../node_modules/popper.js/dist/umd/popper.min.js";
import "script-loader!../../node_modules/bootstrap/js/dist/util";
import "script-loader!../../node_modules/bootstrap/js/dist/collapse";
import "script-loader!../../node_modules/bootstrap/js/dist/dropdown";
import "script-loader!../../node_modules/bootstrap/js/dist/modal";
import "script-loader!../../node_modules/bootstrap/js/dist/tab";


import {oncarrotAddressAutocomplete} from "../../../../plugins/oncarrot-address-autocomplete";
oncarrotAddressAutocomplete(jQuery);

import {oncarrotMap} from "../../../../plugins/oncarrot-map";

import {shimCatch} from "./lib/head-catch";
shimCatch();

import {navbarParentClickableCompat} from "./lib/bootstrap-navwalker";

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Carrot = {
    // All pages
    'common': {
      init: function() {
        $().utmz({ domainName: false });

        navbarParentClickableCompat($);

        // SVG <use> polyfill for IE
        svg4everybody();

        // Ensure full width blocks have perfect alignment
        const scrollBarWidth = window.innerWidth - $(document).width();
        document.documentElement.style.setProperty(
          "--scrollbar-width",
          scrollBarWidth + "px"
        );

        // Responsive videos
        fluidvids.init({
          selector: ['iframe'],
          players: ['www.youtube.com', 'player.vimeo.com']
        });

        // Process Carrot Map Queue
        oncarrotMap();

        // Datepicker
        $('.datepicker').each(function(e) {
          e = $(this);

          var dateFormat;
          if (e.hasClass('mdy')) {
            dateFormat = 'mm/dd/yy';
          } else if (e.hasClass('dmy')) {
            dateFormat = 'dd/mm/yy';
          } else if (e.hasClass('dmy_dash')) {
            dateFormat = 'dd-mm-yy';
          } else if (e.hasClass('dmy_dot')) {
            dateFormat = 'dd.mm.yy';
          } else if (e.hasClass('ymd_slash')) {
            dateFormat = 'yy/mm/dd';
          } else if (e.hasClass('ymd_dash')) {
            dateFormat = 'yy-mm-dd';
          } else if (e.hasClass('ymd_dot')) {
            dateFormat = 'yy.mm.dd';
          }
          var dateFormatAlt = dateFormat.replace('yy', 'yyyy');

          if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            $('.gform_wrapper input.datepicker').removeAttr('type').prop('type', 'date').attr('dateformat', dateFormat);
          } else {
            $('.datepicker').pickadate({
              format: dateFormatAlt
            });
          }
        });

        // Testimonials widget
        // Arrows from Geomicons:
        // - https://github.com/jxnblk/geomicons-open/blob/master/dist/icons/chevronLeft.svg
        // - https://github.com/jxnblk/geomicons-open/blob/master/dist/icons/chevronRight.svg
        $('.widget_oncarrot_testimonial .testimonials').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="currentcolor"><path d="M20 1 L24 5 L14 16 L24 27 L20 31 L6 16 z"></path></svg></button>',
          nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="currentcolor"><path d="M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"></path></svg></button>',
          fade: true
        });

        // Share buttons
        $('.entry-share-btns a, a.sharewindow').on('click', function(e) {
          e.preventDefault();
          var link = $(this).attr('href');
          var width = 840;
          var height = 464;
          var popupName = 'popup_' + width + 'x' + height;
          var left = (screen.width-width) / 2;
          var top = 100;
          var params = 'width=' + width + ',height=' + height + ',location=no,menubar=no,scrollbars=yes,status=no,toolbar=no,left=' + left + ',top=' + top;
          window[popupName] = window.open(link, popupName, params);
          if (window.focus) {
            window[popupName].focus();
          }
          return true;
        });

        // Auto-submit specific forms when a select changes
        $('.autosubmit select').one('change', function() {
          $(this).parents("form").addClass('disabled');
          $(this).parents("form").submit();
        });

        // Add address to first textarea on property inquiry form
        var inquiryForm = $('.widget-inquiry form, #propertyInquiryForm form');
        if (inquiryForm.length > 0) {
          if (!$(inquiryForm).find('textarea:first').val()) {
            var propertyAddress;
            if ($('.property-address-full').length > 0) {
              propertyAddress = $('.property-address-full').html();
            }

            if ($('.ihf-address').length > 0) {
              propertyAddress = $('.ihf-address').html();
            }

            propertyAddress = propertyAddress.replace(/<br\s*\/?>/gi, ' ');
            $(inquiryForm).find('textarea:first').val('I am interested in ' + propertyAddress);
          }
        }

        // Compatibility with Gutenberg on this theme with Soil's .entry-content-asset wrap on oEmbed's, Carrot YouTube lazyloading, and FitVids
        $('.wp-block-embed__wrapper .entry-content-asset').unwrap();

        // Columns block
        if ($('.wp-block-columns').length > 0) {
          $('.wp-block-columns').each(function () {
            $(this).addClass('has-' + $(this).children().length + '-columns');
          });
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // Supplement placeholder values for inline hero form layout
        jQuery(".hero-layout-inline .gform_fields :text").attr("placeholder", function() {
          var eId         = jQuery(this).attr("id");
          var placeholder = jQuery(this).attr("placeholder");
          var label       = jQuery(this).parents("form").find("label[for="+eId+"]");
          if (eId && !placeholder && label.length == 1) {
            jQuery(this).attr("placeholder", jQuery(label).text());
          }
        });
      }
    },
    // Single property page
    'single_property': {
      init: function() {
        $('.slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.slider-nav'
        });
        $('.slider-nav').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
          arrows: true,
          prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="24" height="24" fill="#aaa"><path d="M20 1 L24 5 L14 16 L24 27 L20 31 L6 16 z"></path></svg></button>',
          nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="24" height="24" fill="#aaa"><path d="M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"></path></svg></button>',
          focusOnSelect: true
        });
      }
    },
    // Single IDX property page
    'single_idx_property': {
      init: function () {
        // Move inquiry CTA from end of content to above tabs
        if ($('.main .inquiry-btn-wrap').length > 0) {
          $('.main .inquiry-btn-wrap').insertBefore('#ihf-detail-extrainfotabs');
          $('.main .inquiry-btn-wrap').clone().insertBefore('#ihf-detail-extrainfotabs.visible-xs');
        }

        if ($('.main .widget-inquiry').length > 0) {
          $('.main .widget-inquiry').insertBefore('#ihf-detail-extrainfotabs');
          $('.main .widget-inquiry').clone().insertBefore('#ihf-detail-extrainfotabs.visible-xs');
        }
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Carrot;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



// WEBPACK FOOTER //
// ./assets/scripts/main.js